import { Environment } from "@omni/types/enums/environment.enum";
import { FeatureToggleKey } from "@omni/types/enums/featureToggleKey.enum";
import { entries } from "@omni/utils/object.utils";
import queryString from "query-string";
import { useState } from "react";
import { shallowEqual, useSelector } from "react-redux";

import {
    useFeatureToggle,
    useFeatureToggleContext
} from "@/context/featureToggles.context";
import { getProductComparisonSkuList } from "@/redux/modules/value/productComparisonSkuList/productComparisonSkuList.selectors";
import { getProductDetail } from "@/redux/modules/value/productDetail/productDetail.selectors";
import FeatureTogglesService from "@/services/featureToggle/featureToggles.service";

import { FeatureSwitchComponent } from "./featureSwitch.component";

import "./featureSwitch.scss";

import { isDefined } from "@omni/utils/helper.utils";

import { Config } from "@/utils/config.utils";

const FeatureSwitchContainer = () => {
    const hasComparison = !!useSelector(getProductComparisonSkuList)?.length;
    const hasOrderButton = useSelector(
        getProductDetail,
        shallowEqual
    ).stickyOrderButton;

    const [isOpen, setIsOpen] = useState(false);

    const featureToggles = useFeatureToggleContext();

    const featureSwitchUiEnabled = useFeatureToggle(
        FeatureToggleKey.DEBUG_FEATURE_SWITCH_UI
    );

    const features = entries(featureToggles).map(([key, value]) => ({
        name: key,
        value: value,
        serverValue: Config["feature-toggles"][key] ?? null
    }));

    const isEnabled =
        isDefined(Config.general.environment) &&
        Config.general.environment !== Environment.Prod &&
        (featureSwitchUiEnabled ||
            queryString.parse(location.search, { parseBooleans: true })
                .featureswitchui);

    const handleOnToggleDrawer = (state?: boolean) => {
        if (state !== undefined) {
            setIsOpen(state);
            return;
        }

        setIsOpen((state) => !state);
    };

    const handleOnToggleFeature = (name: FeatureToggleKey, value: boolean) => {
        FeatureTogglesService.setFeature(name, value);
    };

    if (!isEnabled) {
        return null;
    }

    return (
        <FeatureSwitchComponent
            isOpen={isOpen}
            features={features}
            bottomControlsVisible={hasComparison || hasOrderButton}
            onToggle={handleOnToggleDrawer}
            onToggleFeature={handleOnToggleFeature}
        />
    );
};

export { FeatureSwitchContainer };
